export const skeletonDefaultStyle = (theme, variant) => {
  return {
    backgroundColor: theme.tokens.SemColorSurfaceMuted,
    ...(variant.type === 'rounded' || variant.type === 'text' ? {
      borderRadius: '4px'
    } : {}),
    transform: 'none'
  };
};